import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { getDailyFX } from "@/lib/dailyFX";

const PAIRS = [
  ["USD", "CNY"], ["USD", "INR"], ["USD", "EUR"], ["USD", "GBP"],
  ["USD", "AED"], ["USD", "AUD"], ["USD", "SGD"], ["USD", "JPY"],
];

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api/tools/fx`;
const CACHE_KEY = "fortune.fx.daily.tools";

export default function CurrencyStrip() {
  const [rates, setRates] = useState(null);
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    let alive = true;
    // Daily-cached FX (one fetch per 24h per browser)
    getDailyFX(API_URL, CACHE_KEY)
      .then((fx) => { if (alive && fx?.rates) setRates(fx.rates); })
      .catch(() => {});
    // Settings remains live (small, cheap)
    api.get("/cms/settings")
      .then((r) => { if (alive && r.data?.currency_strip_enabled === false) setEnabled(false); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!enabled || !rates) return null;

  return (
    <div className="hidden md:block bg-[#12283F] border-b border-[#B8965A]/15" data-testid="currency-strip">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex items-center justify-between py-1.5 text-[10px] uppercase tracking-[0.14em]">
        <div className="flex items-center gap-5 text-white/55 overflow-x-auto">
          <span className="text-[#B8965A] font-semibold whitespace-nowrap">FX · Daily</span>
          {PAIRS.map(([from, to]) => {
            const v = rates[to];
            if (v == null) return null;
            return (
              <span key={`${from}-${to}`} className="whitespace-nowrap" data-testid={`fx-${from}-${to}`}>
                <span className="text-white/55">{from} {String.fromCharCode(8594)} {to}</span>{" "}
                <span className="text-white/90 font-semibold">{Number(v).toLocaleString(undefined, { maximumFractionDigits: 2 })}</span>
              </span>
            );
          })}
        </div>
        <a
          href="https://wa.me/8613169440367"
          target="_blank"
          rel="noreferrer"
          className="hidden md:inline-flex items-center gap-2 text-[#B8965A] hover:text-white whitespace-nowrap"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-[#B8965A] animate-pulse" />
          On WhatsApp · WeChat · +86 131 6944 0367
        </a>
      </div>
    </div>
  );
}
